import { css } from '@emotion/core'
import { breakpoints } from '~/utils/styles'
import { palette } from '~/utils/colors'

export const container = css`
	display: flex;
	justify-content: center;
	gap: 10px;
`

export const pagination_btn = css`
	width: 44px;
	height: 44px;
	display: grid;
	place-items: center;
	border: 1px solid ${palette.grey['500']};
	border-radius: 4px;
    font-weight: 500;

	@media (min-width: ${breakpoints.tablet}px) {
		width: 48px;
		height: 48px;
	}

	:disabled {
		border: none;
	}
`

export const chevron_icon = css`
	width: 7px;
`